import { App } from "@capacitor/app"
import { Capacitor } from "@capacitor/core"
import { promiseTimeout } from "@vueuse/core"

const isNative = () => Capacitor.isNativePlatform()

const getVersion = async (): Promise<string> => {
  const appInfo = await App.getInfo()
  return appInfo.version
}

const getVersionWithTimeout = async (): Promise<string> => {
  const RESOLVE_TIMEOUT_MS = 1000
  return Promise.race([
    getVersion(),
    promiseTimeout(RESOLVE_TIMEOUT_MS).then(() => "1.0.0"),
  ])
}
/**
 * If window.mobileApp exists, that means we are currently inside an in-app
 * browser.
 **/
const isInAppBrowser = () => window.mobileApp !== undefined

const getPlatform = () => Capacitor.getPlatform()

const isIos = () => getPlatform() === "ios"

const isAndroid = () => getPlatform() === "android"

const getVersionString = async (): Promise<string> => {
  const appInfo = await App.getInfo()

  return `v${appInfo.version} build ${appInfo.build}`
}

export default {
  isNative,
  isInAppBrowser,
  getPlatform,
  isIos,
  isAndroid,
  getVersionString,
  getVersionWithTimeout,
}
